import { useEffect } from 'react';

import { usePsapConfiguration } from '../psap/PsapConfigurationContext';

export type NgPageHeaderProps = {
  title?: string;
  separator?: string;
};

const DEFAULT_APP_NAME = 'NG-SO Portal';

export function NgPageHeader({ title, separator = ' - ' }: NgPageHeaderProps) {
  const configuration = usePsapConfiguration();
  const appTitle = configuration?.psapPortalConfiguration.appName ?? DEFAULT_APP_NAME;
  const effectivePageTitle = title == null ? appTitle : `${title}${separator}${appTitle}`;

  useEffect(() => {
    document.title = effectivePageTitle;
  }, [effectivePageTitle]);

  return null;
}
